const namespaced = true

const state = {
    sessionCache: [],
    presentationCache: [],
    personCache: [],
    abstractCache: [],
    industryCache: [],

}

const actions = {

}
const mutations = {
    setCache: (state, data) => {
        let items = data.items;
        let area = data.area;
     //   console.log('🗄️  search/setCache mutation:', area, '→', items.length, 'items');
        state[area+ 'Cache'] = items
       // console.log('✓ State updated:', area + 'Cache length =', state[area+ 'Cache'].length);
    },
}
const getters = {
}

export const search = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
